/* tslint:disable */
/* eslint-disable */
/**
 * Business Orchestration layer (BOL) Notifications API
 * Business Orchestration layer (BOL) Notifications API.  This API is used to manage subscriptions and consumers for BOL notifications. 
 *
 * The version of the OpenAPI document: 7.2.1-develop.2
 * Contact: benoit.tiers@logist-x.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * @type EqualsQueryValue
 * 
 * @export
 */
export type EqualsQueryValue = boolean | number | string;

export function EqualsQueryValueFromJSON(json: any): EqualsQueryValue {
    return EqualsQueryValueFromJSONTyped(json, false);
}

export function EqualsQueryValueFromJSONTyped(json: any, ignoreDiscriminator: boolean): EqualsQueryValue {
    if (json == null) {
        return json;
    }
    if (typeof json === 'boolean') {
        return json;
    }
    if (typeof json === 'number') {
        return json;
    }
    if (typeof json === 'number') {
        return json;
    }
    if (typeof json === 'string') {
        return json;
    }
    return {} as any;
}

export function EqualsQueryValueToJSON(json: any): any {
    return EqualsQueryValueToJSONTyped(json, false);
}

export function EqualsQueryValueToJSONTyped(value?: EqualsQueryValue | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    if (typeof value === 'boolean') {
        return value;
    }
    if (typeof value === 'number') {
        return value;
    }
    if (typeof value === 'number') {
        return value;
    }
    if (typeof value === 'string') {
        return value;
    }
    return {};
}

